<template>
  <v-dialog
    v-if="getDialog.playView"
    :value="getDialog.playView"
    max-width="fit-content"
    content-class="playview-dialog"
    persistent
  >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ getPlayViewMachine.title }}</h5>
        <button
          type="button"
          class="btn-close"
          @click="closePlayView()"
        ></button>
      </div>
      <div class="modal-body">
        <div class="video-area screen2" v-if="getMachineGameType == '2screen'">
          <div class="multi-screen">
            <MachineDeviceVideoStream
              id="capture_up"
              :play="devices.capture_up"
              :device="devices.capture_up"
            />
          </div>
          <div class="multi-screen">
            <MachineDeviceVideoStream
              id="capture_down"
              :play="devices.capture_down"
              :device="devices.capture_down"
            />
          </div>
        </div>
        <div
          class="video-area screen2"
          v-else-if="getMachineGameType == '3screen'"
        >
          <div class="multi-screen">
            <MachineDeviceVideoStream
              id="capture_up"
              :play="devices.capture_up"
              :device="devices.capture_up"
            />
          </div>
          <div class="multi-screen">
            <MachineDeviceVideoStream
              id="capture_down"
              :play="devices.capture_down"
              :device="devices.capture_down"
            />
          </div>
        </div>
        <div class="video-area wide" v-else>
          <div class="wide-screen">
            <MachineDeviceVideoStream
              id="capture_down"
              :play="devices.capture_down"
              :device="devices.capture_down"
            />
          </div>
        </div>

        <div class="play-button">
          <button @click="$emit('handleGame')">PLAY NOW</button>
        </div>
      </div>
    </div>
  </v-dialog>
</template>
<script>
import { AuthNamespace } from "@/store/auth";
import { MachineNamespace } from "@/store/machine";
import {
  MachineDeviceActions,
  MachineDeviceNamespace,
} from "@/store/machineDevice";
import MachineDeviceVideoStream from "@views/components/common/MachineDeviceVideoStream.vue";
import { mapActions, mapGetters } from "vuex";
import DialogMixin from "@/mixins/dialogMixin";

export default {
  mixins: [DialogMixin],
  components: {
    MachineDeviceVideoStream,
  },
  computed: {
    ...mapGetters(AuthNamespace, ["getExternalToken"]),

    ...mapGetters(MachineDeviceNamespace, ["getMachineDeviceList"]),

    ...mapGetters(MachineNamespace, ["getMachineGameType"]),
  },
  data() {
    return {
      devices: {
        capture_up: null,
        capture_down: null,
      },
    };
  },
  methods: {
    ...mapActions(MachineDeviceNamespace, {
      ACTION_READ_MACHINE_DEVICE_LIST:
        MachineDeviceActions.ACTION_READ_MACHINE_DEVICE_LIST,
    }),
    closePlayView() {
      this.setPlayViewMachine(null);
      this.setDialog("playView", false);
    },
  },
  watch: {
    "getDialog.playView"(visible) {
      if (visible && this.getPlayViewMachine) {
        this.ACTION_READ_MACHINE_DEVICE_LIST({
          machine_id: this.getPlayViewMachine.id,
          external_token: this.$store.getters["auth/getExternalToken"],
        }).then(() => {
          console.log(this.getMachineDeviceList);
          if (this.getMachineDeviceList.length) {
            this.devices.capture_up = this.getMachineDeviceList.find(
              (e) => e.type === "Capture_up"
            );
            this.devices.capture_down = this.getMachineDeviceList.find(
              (e) => e.type === "Capture_down"
            );
          }
        });
      }
    },
  },
};
</script>
